<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit plan details" onOk="handleOk">
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Plan</a-button>
      </template>
      <a-spin :spinning="spinning">
          <a-form class="mb-4" :form="form">
              <a-form-item label="Name">
                  <a-input
                      placeholder="Name"
                      v-decorator="['name', {rules: [{ required: true, message: 'Please input plan name!' }]}]"
                  />
              </a-form-item>
              <a-form-item label="Description">
                  <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
              </a-form-item>
              <a-form-item label="Price">
                <a-input-number
                  placeholder="Price"
                  v-decorator="['price', {rules: [{ required: true, message: 'Please input plan price!' }]}]"
                  :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                  :min="0"
                  :width="200"
                />
              </a-form-item>
          </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'

export default {
  name: 'EditPlan',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      boardId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openPlanEditModal', this.showModal)
  },
  methods: {
    showModal: function(boardId) {
      this.boardId = boardId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/plan/' + boardId).then(({ data }) => {
        const editData = pick({ ...data.data }, ['name', 'description', 'price'])
        const fieldsData = mapValues({ ...editData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/plan/' + this.boardId, {
                  name: values.name,
                  description: values.description,
                  price: values.price,
                })
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: `Plan ${data.data.name} updated successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
